import { createContext } from "preact";
import { useContext } from "preact/hooks";
import { useCart } from "@/hooks/useCart";

type CartContextValue = ReturnType<typeof useCart>;

const CartContext = createContext<CartContextValue | null>(null);

export function CartProvider({
  children,
}: {
  children: preact.ComponentChildren;
}) {
  const cart = useCart();
  return (
    <CartContext.Provider value={cart}>{children}</CartContext.Provider>
  );
}

export function useCartContext() {
  const ctx = useContext(CartContext);
  if (!ctx) {
    throw new Error("useCartContext must be used within CartProvider");
  }
  return ctx;
}
